import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=6f4bc228&scoped=true"
import script from "./fuwu.vue?vue&type=script&lang=js"
export * from "./fuwu.vue?vue&type=script&lang=js"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=6f4bc228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4bc228",
  null
  
)

export default component.exports